module.exports = __webpack_public_path__ + "img/my.cdd3757.svg";